// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../css-loader/dist/cjs.js!./widget.css");
var ___CSS_LOADER_AT_RULE_IMPORT_1___ = require("-!../../../css-loader/dist/cjs.js!./commandpalette.css");
var ___CSS_LOADER_AT_RULE_IMPORT_2___ = require("-!../../../css-loader/dist/cjs.js!./dockpanel.css");
var ___CSS_LOADER_AT_RULE_IMPORT_3___ = require("-!../../../css-loader/dist/cjs.js!./menu.css");
var ___CSS_LOADER_AT_RULE_IMPORT_4___ = require("-!../../../css-loader/dist/cjs.js!./menubar.css");
var ___CSS_LOADER_AT_RULE_IMPORT_5___ = require("-!../../../css-loader/dist/cjs.js!./scrollbar.css");
var ___CSS_LOADER_AT_RULE_IMPORT_6___ = require("-!../../../css-loader/dist/cjs.js!./splitpanel.css");
var ___CSS_LOADER_AT_RULE_IMPORT_7___ = require("-!../../../css-loader/dist/cjs.js!./tabbar.css");
var ___CSS_LOADER_AT_RULE_IMPORT_8___ = require("-!../../../css-loader/dist/cjs.js!./tabpanel.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
// Module
exports.push([module.id, "/*-----------------------------------------------------------------------------\n| Copyright (c) Jupyter Development Team.\n| Copyright (c) 2014-2017, PhosphorJS Contributors\n|\n| Distributed under the terms of the BSD 3-Clause License.\n|\n| The full license is in the file LICENSE, distributed with this software.\n|----------------------------------------------------------------------------*/\n", ""]);
// Exports
module.exports = exports;
